import React from "react";
import { useHistory } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { WHITE } from "../colors";
import { FORM_SUBMIT_ROUTE } from "../routes";
import FormEditService from "../services/formEditService";
import Banner from "../components/banners/Banner";

export default function FormEditHistoryListContainer(props) {
  const { userClicked } = props;
  let history = useHistory();
  const approveForm = async (id) => {
    const res = await FormEditService.approveForm(id);
    props.getPageInfo();
  };
  return (
    <div>
      {props?.formEdits?.length > 0 ? (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
          <Table
            sx={{
              minWidth: 650,
              backgroundColor: WHITE,
            }}
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead>
              <TableRow>
                {/* <TableCell padding="checkbox">
                <Checkbox color="primary" checked={false} />
              </TableCell> */}
                <TableCell></TableCell>
                <TableCell align="center">Related Customer</TableCell>
                <TableCell align="center">Related Form</TableCell>
                <TableCell align="center">Edit By</TableCell>
                <TableCell align="center">Approve</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props?.formEdits?.map((row) => (
                <TableRow
                  hover
                  key={row.id}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  {/* <TableCell padding="checkbox">
                  <Checkbox color="primary" checked={false} />
                </TableCell> */}

                  <TableCell
                    align="center"
                    onClick={() =>
                      history.push(
                        `${FORM_SUBMIT_ROUTE}?type=${row.type}&customer=${row.customer}&form=${row.id}`
                      )
                    }
                  >
                    {row.updatedAt}
                  </TableCell>
                  <TableCell
                    align="center"
                    onClick={() =>
                      history.push(
                        `${FORM_SUBMIT_ROUTE}?type=${row.type}&customer=${row.customer}&form=${row.id}`
                      )
                    }
                  >
                    {row?.Customer?.full_name}
                  </TableCell>
                  <TableCell
                    align="center"
                    onClick={() =>
                      history.push(
                        `${FORM_SUBMIT_ROUTE}?type=${row.type}&customer=${row.customer}&form=${row.id}`
                      )
                    }
                  >
                    {row.type}
                  </TableCell>
                  <TableCell
                    align="center"
                    onClick={() =>
                      history.push(
                        `${FORM_SUBMIT_ROUTE}?type=${row.type}&customer=${row.customer}&form=${row.id}`
                      )
                    }
                  >
                    {row?.Employee?.name}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton onClick={() => approveForm(row.id)}>
                      <CheckIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Banner message="No new form submissions" />
      )}
    </div>
  );
}
